import {PhotoGuideLayoutItem} from '../types/PhotoGuideLayoutItem';

export const toPhotoGuideLayoutRequest = (layout: PhotoGuideLayoutItem[]) =>
  layout.map((item) => ({
    photoType: item.kind === 'slot' ? item.photoType : null,
    saleVehiclePhotoId: item.image?.id ?? null,
  }));
